// Jobs, visits and the schedule.
import { createRoute } from "@tanstack/react-router";
import { ScheduleTools } from "../../screens/Field";
import { JobForm } from "../../screens/jobs/Form";
import { JobsList } from "../../screens/jobs/List";
import { JobPage } from "../../screens/jobs/Page";
import { Schedule } from "../../screens/Schedule";
import { SectionMessages } from "../../screens/settings/Automations";
import { FeatureSettings } from "../../screens/settings/Feature";
import { ScheduleSettings } from "../../screens/settings/Schedule";
import { VisitPage } from "../../screens/Visit";
import { Allowed, app, page, sectionMessagePage } from "./base";

const jobNew = createRoute({
  getParentRoute: () => app,
  path: "/jobs/new",
  validateSearch: (s: Record<string, unknown>): { clientId?: string; quoteId?: string } => ({
    ...(typeof s.clientId === "string" && s.clientId ? { clientId: s.clientId } : {}),
    ...(typeof s.quoteId === "string" && s.quoteId ? { quoteId: s.quoteId } : {}),
  }),
  component: function JobNewRoute() {
    const { clientId, quoteId } = jobNew.useSearch();
    return (
      <Allowed action="job.update">
        <JobForm key={quoteId ?? clientId ?? "new"} {...(clientId ? { clientId } : {})} {...(quoteId ? { quoteId } : {})} />
      </Allowed>
    );
  },
});

const jobPage = createRoute({
  getParentRoute: () => app,
  path: "/jobs/$id",
  component: function JobRoute() {
    const { id } = jobPage.useParams();
    return (
      <Allowed action="job.read">
        <JobPage key={id} id={id} />
      </Allowed>
    );
  },
});

const jobEdit = createRoute({
  getParentRoute: () => app,
  path: "/jobs/$id/edit",
  component: function JobEditRoute() {
    const { id } = jobEdit.useParams();
    return (
      <Allowed action="job.update">
        <JobForm key={id} id={id} />
      </Allowed>
    );
  },
});

const visitPage = createRoute({
  getParentRoute: () => app,
  path: "/visits/$ref",
  component: function VisitRoute() {
    const { ref } = visitPage.useParams();
    return (
      <Allowed action="visit.read">
        <VisitPage refId={ref} />
      </Allowed>
    );
  },
});

export const jobRoutes = [
  page("/schedule/tools", () => (
    <Allowed action="schedule.read">
      <ScheduleTools />
    </Allowed>
  )),
  page("/schedule/settings", () => (
    <Allowed action="settings.read">
      <FeatureSettings title="Schedule settings" back="/schedule" backLabel="Schedule">
        <SectionMessages section="schedule" />
        <ScheduleSettings />
      </FeatureSettings>
    </Allowed>
  )),
  page("/jobs", () => (
    <Allowed action="job.read">
      <JobsList />
    </Allowed>
  )),
  jobNew,
  jobPage,
  jobEdit,
  page("/schedule", () => (
    <Allowed action="schedule.read">
      <Schedule />
    </Allowed>
  )),
  visitPage,
  sectionMessagePage("/schedule/settings/messages/$kind", "schedule"),
] as const;
